import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Grandmaster, GMList } from 'lo-bahamut';
import { ActionPasser, ErrorMessages, Logger, BahamutHelper } from 'lo-bahamut';
import { LoadingSpinnerService } from '../_core/services/loading-spinner.service';
import { CareFindrTenantConfigurationService } from '../_core/apiV2/services/care-findr-tenant-configuration.service';
import { Router } from '@angular/router';
import { Subject, forkJoin, takeUntil } from 'rxjs';
import { CURRENT_TENNANT } from '../app.component';
import {ProviderSearchService} from "../_core/apiV2/services/provider-search.service";
import {SearchState, SearchStateService} from "../_core/services/search-state.service";
import {isNull, omitBy} from "lodash-es";
import { SearchService } from '../_core/services/search.service';
import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {option} from "../search-start-v2/search-start-v2.component";
import {level} from "lo-bahamut-v1/types";
import * as Handlebars from "handlebars"

@Component({
  selector: 'app-carefindr-ai',
  templateUrl: './carefindr-ai.component.html',
  styleUrls: ['./carefindr-ai.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CarefindrAiComponent implements OnInit {
  private url: any = "../../assets/nls-carefindr-ai.json";
  private _data: any;
  destroyed$ = new Subject<void>();
  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;
  searchState: SearchState = {
    Query: {
      sortBy: 'distance-asc',
    },
    Extra: {

    },
  };
  places: any[] =[];

  constructor(
    private loadingSpinnerService: LoadingSpinnerService,
    private providerSearchService: ProviderSearchService,
    public actionPasser: ActionPasser,
    private searchStateService: SearchStateService,
    public gmList: GMList,
    public logger: Logger,
    private lobhelper: BahamutHelper,
    public errorMessages: ErrorMessages,
    public grandmaster: Grandmaster,
    private tenantConfigService: CareFindrTenantConfigurationService,
    private router: Router,
    private searchService: SearchService,
    private http: HttpClient
  ) {}

  ngOnInit() {

    this.getCareFindrJson();

    // Comment out tenant config loading so sample config is used
    // this.loadingSpinnerService.showLoader();
    // const tenantComponentJs$ = this.tenantConfigService.getTenantComponentBluePrint({page_name: 'patient-search', tenant: CURRENT_TENNANT});
    // forkJoin([tenantComponentJs$])
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe({
    //     next: ([componentJsResponse]) => {
    //       let response: any = {}
    //       if (typeof componentJsResponse === "string") {
    //         response = JSON.parse(componentJsResponse);
    //       } else {
    //         response = componentJsResponse;
    //       }
    //       this._data = response.componentsConfig;
    //       this.errorMessages.defaultErrorMessages = response.errorMessages;
    //     },
    //     error: (err) => {
    //       if (err.status === 403) {
    //         this.router.navigate(['error-handler'], {state: { msg:"Access denied"}});
    //       }
    //     },
    //     complete: () => {
    //       this.loadingSpinnerService.hideLoader();
    //     }
    //   });
    this.actionPasser.groupEmitter$.pipe(takeUntil(this.destroyed$)).subscribe((group: any) => {
      if (group !== undefined && Object.keys(group).length !== 0) {
        switch (group[0].groupName) {
          case "handle-ai-search-input":
            var aiInputRef = this.gmList.gmList[group[0].uniqueKey].reference;
            var aiSearchBtnRef = this.gmList.gmList[group[1].uniqueKey].reference;
            aiSearchBtnRef.disabled = aiInputRef.data.trim().length < 1;
            break;
          case "ai-search-button":
            // // Below is the code to hit the google api directly and there is a CORS error inorder to fix that who ever works on that please go through "https://developers.google.com/maps/documentation/javascript/legacy/places"
            // let paramValue = "Baltimore, MD, USA";
            // let encodedParam = encodeURIComponent(paramValue);
            // console.log(encodedParam);
            // // const apiUrl = `https://places.googleapis.com/v1/places:${encodedParam}`;
            // const apiKey = '';
            // const url = `https://maps.googleapis.com/maps/api/place/textsearch/json?query=${encodeURIComponent(paramValue)}&key=${apiKey}`;
            // this.http.get<any>(url).subscribe(response => {
            //   this.places = response.results;
            // });

            // Get the UK of aiInput component
            const searchOuterContainerUk = this.lobhelper.getDesiredChildUK("1", "careFindrSearchPageOuterContainer");
            const containerUk = this.lobhelper.getDesiredChildUK(searchOuterContainerUk, "careFindrSearchPageInnerContainer");
            const searchPageContainerUk = this.lobhelper.getDesiredChildUK(containerUk, "SearchPageContainer");
            const aiInputUk = this.lobhelper.getDesiredChildUK(searchPageContainerUk, "aiInput");
            var aiInputRef = this.gmList.gmList[aiInputUk].reference

            if (aiInputRef.data.length >= 1) {
              this.callAiSearch(aiInputRef.data);
            } else {
              this.logger.warn("AI input is empty");
            }
            break;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  addToGrandmaster(viewRef: any, data: any) {
    this.grandmaster.addChildrenToThisView(viewRef, data);
  }

  callAiSearch(queryText: string) {let lastQueryText;
    if(lastQueryText === queryText) return;
    this.loadingSpinnerService.showLoader();
    lastQueryText = queryText.trim();
    this.searchState.Extra.searchType = 'nl-search';
    // this.searchState.Query.name = queryText;
    // this.searchStateService.updateSearchCriteria(this.searchState);
    const requestPayload = {
      query: queryText.trim()
    };
    this.providerSearchService.naturalLanguageProviderSearchCareFindr({
      'x-tenant-id': CURRENT_TENNANT,
      'x-persona': 'user',
      body: requestPayload
    }).subscribe({
      next: (response: any) => {
        if (response) {
          this.logger.log(response);
          this.loadingSpinnerService.hideLoader();

          if(response.query.location.message === "LOCATION_NOT_PROVIDED"){
            let errorModelUk = this.lobhelper.getDesiredChildUK("1", "errorModal");
            this.loadingSpinnerService.hideLoader();
            let errorModalRef = this.gmList.gmList[errorModelUk].reference;
            const modalBody = this.gmList.gmList[errorModalRef.children[0]].reference;
            const htmlRef = this.gmList.gmList[modalBody.children[0]].reference;
            htmlRef.code = "Location is missing please search based on the location"
            errorModalRef.hide = false;
            return
          }

          // Create a deep copy of the response query
          const queryCopy = JSON.parse(JSON.stringify(response?.query));

          // Save the location text to Extra before removing it
          const locationText = queryCopy?.location?.text || '';

          // Remove the text property from location if it exists
          if (queryCopy?.location?.text) {
            delete queryCopy.location.text;
          }

          // Remove attrs if it's an empty object
          if (queryCopy?.attrs && Object.keys(queryCopy.attrs).length === 0) {
            delete queryCopy.attrs;
          }

          // ✅ Remove all keys with null values (top-level only)
          for (const key in queryCopy) {
            if (queryCopy[key] === null) {
              delete queryCopy[key];
            }
          }

          // Ensure sortBy has a default value
          if (!queryCopy.sortBy) {
            queryCopy.sortBy = "distance-asc";
          }

          // Update the search state
          Object.assign(this.searchState, {
            Query: queryCopy,
            Extra: {
              ...this.searchState.Extra,
              locationText: locationText,
              aiSearch: queryText.trim()
            }
          });

          this.searchStateService.updateSearchCriteria(this.searchState);
          this.router.navigate(['nls-search-results-v2']);
        }

      },
      error: (err: HttpErrorResponse) => {
        this.logger.error(err);
        console.log(err)
        let errorModelUk = this.lobhelper.getDesiredChildUK("1", "errorModal");
        this.loadingSpinnerService.hideLoader();
        let errorModalRef = this.gmList.gmList[errorModelUk].reference;
        const modalBody = this.gmList.gmList[errorModalRef.children[0]].reference;
        const htmlRef = this.gmList.gmList[modalBody.children[0]].reference;
        htmlRef.code = err.status === 400
          ? err.error?.message
          : err.error?.errors?.map((er: { errorMessage: string }) => er.errorMessage).join('<br>');
        errorModalRef.hide = false;
      }
    });

  }

  getCareFindrJson(){
    // this.searchService.getCareFindrJson(this.url).subscribe(template => {
    this.tenantConfigService.getTenantBluePrint({page_name: `nls-carefindr-ai`, tenant: CURRENT_TENNANT}).subscribe(response => {
      if(response == null) return;
      let res = atob(response);
      const template = Handlebars.compile(res);
      const renderedTemplate = template(template); // 'template' is the compiled Handlebars template
      this._data = JSON.parse(renderedTemplate).componentsConfig;
      this.errorMessages.defaultErrorMessages = JSON.parse(renderedTemplate).errorMessages;
      this.loadingSpinnerService.hideLoader();
    })
  }
}
